import { useNavigate,useNavigation,useLocation,useMatches,useParams } from 'react-router-dom'; 

const useRouter = () => {
  const navigate = useNavigate();
  const location = useLocation();
  return { navigate, location,useMatches,useNavigation,useParams }
};

export { useRouter };